import { render, staticRenderFns } from "./DJindex.vue?vue&type=template&id=4be52bf2&"
import script from "./DJindex.vue?vue&type=script&lang=js&"
export * from "./DJindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports